import { atom } from "recoil";
import { Point } from "../../generated/graphql";

// main

export const currentPointState = atom<Point | null>({
    key: "currentPointState",
    default: null,
});
